import { RenderBox, RenderedBookmark } from '../rendering'
import { renderElement } from '../document'

type BookmarkProps = {
  title: string
  path?: string
}

export class BookmarkRenderBox extends RenderBox<BookmarkProps> {
  performLayout(): void {
    this.box = { x: 0, y: 0, width: 0, height: 0 }
  }

  bookmark(): RenderedBookmark {
    return {
      title: this.props.title,
      path: this.props.path,
      bounds: this.box
    }
  }
}

export function Bookmark(props: BookmarkProps) {
  return renderElement(new BookmarkRenderBox(props))
}
